import { useEffect, useState } from 'react';
import { message } from 'antd';

const useNetworkStatus = () => {
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    useEffect(() => {
        const handleOnline = () => setIsOnline(true);
        const handleOffline = () => setIsOnline(false);

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    return isOnline;
};

const NetworkStatusHandler = () => {
    const isOnline = useNetworkStatus();

    useEffect(() => {
        if (!isOnline) {
            message.error('A network error occurred. Please check your connection and try again.');
        }
    }, [isOnline]);

    return null;
};

export default NetworkStatusHandler;